import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

const Pagination = (props) => {
  const { productsCount, pageSize, currentPage, onPageChange } = props;

  const pagesCount = Math.ceil(productsCount / pageSize);
  if (pagesCount === 1) return null;
  const pages = _.range(1, pagesCount + 1);

  return (
    <div className='pagination-block'>
      <div className='paginations'>
        {pages.map((page) => (
          <div
            key={page}
            className={page === currentPage ? 'page-items page-items-active' : 'page-items'}
          >
            <div className='page-link' onClick={() => onPageChange(page)}>
              {page}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

Pagination.propTypes = {
  productsCount: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
};

export default Pagination;
